import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { forkJoin } from 'rxjs';
import { ConsumoFolha } from 'src/app/admihair/api/dto/consumo-folha';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { FolhaPessoaFisica } from 'src/app/admihair/api/dto/folha-pessoa-fisica';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { ConsumoFolhaService } from 'src/app/admihair/service/consumo-folha.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-consumo-editar',
  templateUrl: './consumo-editar.component.html',
  styleUrls: ['./consumo-editar.component.scss']
})
export class ConsumoEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  id?: number;
  exibirSpinner: boolean = false;

  profissionais: Profissional[] = [];
  profissionalSelecionado?: Profissional;
  contas: PlanoContaEmpresa[] = [];
  registro: Date = new Date();
  competencia: Date = new Date();

  consumoFolha?: ConsumoFolha;
  parcelasConsumo: FolhaPessoaFisica[] = [];

  mostrarDialogItem: boolean = false;
  listaItens: any[] = [];

  valorDesconto: number = 0;
  qtdParcelas: number = 0;

  tipoItemSelecionado: number = 4;
  tiposItem: SelectItem[] = [{ label: 'Serviço', value: 4 }, { label: 'Produto', value: 3 }];
  itemServicoSelecionado?: ItemServico;
  itemProdutoSelecionado?: ItemProduto;
  exibirSpinnerDialog: boolean = false;
  exibirRedirecionar?: Boolean = false;

  @ViewChild('filter') filter!: ElementRef;

  constructor(private consumoService: ConsumoFolhaService,
    private itemProdutoService: ItemProdutoService,
    private itemServicoService: ItemServicoService,
    private profissionalService: ProfissionalService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private erroService: ErroService) { }

  ngOnInit(): void {
    this.exibirSpinner = true;
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_CONSUMO');
    this.carregarId();
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoEditar) {
      this.carregarProfissionais();
    }
  }

  carregarId() {
    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  carregarProfissionais() {
    this.profissionalService.listarAtivosPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Profissional[]) => {
        this.profissionais = data;
        this.carregarConsumo();
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  carregarConsumo() {
    this.consumoService.buscarPorId(this.id).subscribe({
      next: (data: ConsumoFolha) => {
        this.consumoFolha = data;
        this.consumoFolha.dataTransacao = new Date(this.consumoFolha.dataTransacao + 'T05:00:00Z')
        if (data.listaFolha) {
          this.parcelasConsumo = data.listaFolha;
          this.parcelasConsumo.forEach(item => item.dataCompetencia = new Date(item.dataCompetencia + 'T05:00:00Z'))
        }
        if (this.parcelasConsumo.length === 0) {
          this.excluirConsumo();
        }
        this.qtdParcelas = this.parcelasConsumo.length
        this.carregarItemSelecionado();
      },
      error: (err: any) => {
        this.exibirSpinner = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  carregarItemSelecionado() {
    if (this.consumoFolha?.codigoPlanoConta === 3) {
      this.tipoItemSelecionado = 3;
      this.itemProdutoService.buscarItemProdutoPorId(this.consumoFolha.itemId).subscribe({
        next: (data: ItemProduto) => {
          this.itemProdutoSelecionado = data;
          this.exibirSpinner = false;
        },
        error: (err: any) => {
          this.exibirSpinner = false;
          this.exibirMensagemErro(err);
        }
      })
    } else if (this.consumoFolha?.codigoPlanoConta === 4) {
      this.tipoItemSelecionado = 4;
      this.itemServicoService.buscarItemServicoPorId(this.consumoFolha.itemId).subscribe({
        next: (data: ItemServico) => {
          this.itemServicoSelecionado = data;
          this.exibirSpinner = false;

        },
        error: (err: any) => {
          this.exibirSpinner = false;
          this.exibirMensagemErro(err);
        }
      })
    }
  }



  excluirConsumo() {
    this.consumoService.excluir(this.id).subscribe({
      next: () => {
        this.exibirRedirecionar = true;
      },
      error: (err: any) => {
        this.exibirRedirecionar = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  atualizar() {
    this.progressoRequisicao = true;
    if (this.consumoFolha?.listaFolha) {
      this.consumoFolha.listaFolha = this.parcelasConsumo
    }
    this.consumoService.atualizar(this.consumoFolha, this.id).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();

      },
      error: (err: any) => {
        this.progressoRequisicao = false;;
        this.exibirMensagemErro(err);
      }
    })
  }

  adicionarItem(item: any) {
    if (item.planoContaEmpresa.codigo === 4) {
      this.itemServicoSelecionado = item;
    } else if (item.planoContaEmpresa.codigo === 3) {
      this.itemProdutoSelecionado = item;
    }
    this.mostrarDialogItem = false;

  }

  abrirDialogItem() {
    this.carregarItens();
    this.mostrarDialogItem = true;
  }

  carregarItens() {
    this.exibirSpinnerDialog = true;
    const status = true;
    if (this.tipoItemSelecionado === 4) {
      this.itemServicoService.listarPorEmpresaIdESituacao(this.empresaSelecionada?.id, status).subscribe({
        next: (data: ItemServico[]) => {
          this.exibirSpinnerDialog = false;
          this.listaItens = data;
        },
        error: (err: any) => {
          this.exibirSpinnerDialog = false;
          this.exibirMensagemErro(err);
        }
      });
    } else if (this.tipoItemSelecionado === 3) {
      this.itemProdutoService.listarPorEmpresaIdEStatus(this.empresaSelecionada?.id, status).subscribe({
        next: (data: ItemServico[]) => {
          this.exibirSpinnerDialog = false;
          this.listaItens = data;
        },
        error: (err: any) => {
          this.exibirSpinnerDialog = false;
          this.exibirMensagemErro(err);
        }
      });
    }


  }

  excluirItemFolha(id: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.consumoService.excluirParcela(id).subscribe({
          next: () => {
            this.carregarConsumo();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  exibirMensagemSucesso() {
    this.messages = this.erroService.handleSuccess();
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
    this.rolarTela();
  }

  redirecionarListagem() {
    this._router.navigate(["/apps/consumo/"], { relativeTo: this.activatedRoute })
  }


  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
